<template>
  <div class="filters__block">
    <button
      type=" button"
      class="filter__trigger"
      @click="togglePanel"
    >
      {{ singleBlockTitle }}
      <span
        class="filter__icon"
        :class="{ 'rotate': !hidePanel }"
      >
        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L7 7L13 1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>
    <div
      v-if="isValidSingleBlock"
      class="filter__panel"
      :class="{'is--hidden': hidePanel }"
    >
      <div
        v-for="(input, index) in singleBlock.filtersection"
        :key="input.value.value"
      >
        <template v-if="index < visibleFiltersCount">
          <singleBlockInput
            :block-input="input"
            :filter_on="singleBlock.on"
            :___inpTD="inputToDelete__"
            :allSelectedFilters__="allSelectedFilters"
            @singleObjectCheck="onCheckboxCheck"
            @removeFilter="onRemoveFilter"
          />
        </template>
      </div>
      <button
        v-show="isShowMore"
        type="button"
        class="filter-toggle__button show-more-button"
        @click="allFiltersShown = !allFiltersShown"
      >
        <span
          class="filter-toggle__button--text"
          v-text="allFiltersShown ? 'SHOW LESS' : 'SHOW MORE'"
        />
      </button>
    </div>
    <div
      v-else
      class="filter__panel"
      :class="{'is--hidden': hidePanel}"
    >
      <div class="range-slider">
        <input
          v-model="sliderMin"
          type="range"
          :min="minPrice"
          :max="maxPrice"
          step="1"
          @change="onMinPrice"
        >
        <span
          class="min-value"
          v-html="addCurrencySymbol(sliderMin)"
        />
        <input
          v-model="sliderMax"
          type="range"
          :min="minPrice"
          :max="maxPrice"
          step="1"
          @change="onMaxPrice"
        >
        <span
          class="max-value"
          v-html="addCurrencySymbol(sliderMax)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import singleBlockInput from '~legacy-vue/vueComponents/CollectionTemplate/singleBlockInput.vue'

import { formatLocalizedPrice } from '~/helpers/format'

export default {
  name: 'SingleBlock',
  delimiters: ['{$', '$}'],
  components: {
    singleBlockInput,
  },
  props: {
    activePanel: {
      type: [Boolean, String],
      default: false,
    },
    allSelectedFilters: Array,
    inputToDelete: Object,
    singleBlock: Object,
  },
  data() {
    return {
      hidePanel: true,
      selectedFilters_: [],
      inputToDelete__: {},
      minAngle: 0,
      maxAngle: 30,
      minPrice: 0,
      maxPrice: 0,
      priceFilter: {},
      allFiltersShown: false,
      visibleFiltersCount: 7,
      windowWidth: window.innerWidth,
    }
  },

  computed: {

    /**
     * Compute a valid facet accordion title.
     * - If 'Price', Attraqt will name the facet Price ($CURRENCY), e.g.
     * '(Price GBP)', '(Price EUR)', so remove parenthesis.
     * @returns {String}
     */
    singleBlockTitle() {
      if (this.singleBlock.on == mint.services.attraqt.priceField) {
        return this.singleBlock.title.replace(/\s*\(.*?\)\s*/g, '')
      }

      return this.singleBlock.title
    },

    sliderMin: {
      get: function() {
        const val = parseInt(this.minAngle)
        return val
      },
      set: function(val) {
        val = parseInt(val)
        if (val > this.maxAngle) {
          this.maxAngle = val
        }
        this.minAngle = val
      },
    },

    /**
     * Check that the current block can be displayed and is valid.
     * @returns {Boolean}
     */
    isValidSingleBlock() {
      return this.singleBlock.on !== window.mint.services.attraqt.priceField
    },

    sliderMax: {
      get: function() {
        const val = parseInt(this.maxAngle)
        return val
      },
      set: function(val) {
        val = parseInt(val)
        if (val < this.minAngle) {
          this.minAngle = val
        }
        this.maxAngle = val
      },
    },
    isShowMore() {
      return (
        this.singleBlock.filtersection.length > 7 && this.windowWidth >= 768
      )
    },
  },
  watch: {
    activePanel: {
      handler() {

        /**
         * If the current active panel is not this one, close it.
         */
        if (this.activePanel === this.singleBlock.title) {
          return
        }
        this.hidePanel = true
      },
      immediate: true,
    },

    inputToDelete: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue.filter_on == window.mint.services.attraqt.priceField) {
          this.setDefaultPriceRanges()
        } else {
          this.inputToDelete__ = newValue
        }
      },
    },

    allSelectedFilters: {
      deep: true,
      handler: function(newValue, oldValue) {
        this.setDefaultPriceRanges()
      },
    },

    priceFilter: {
      deep: true,
      handler: function(newValue, oldValue) {},
    },

    minAngle: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue != this.minPrice) {
        }
      },
    },

    maxAngle: {
      deep: true,
      handler: function(newValue, oldValue) {},
    },
    singleBlock: {
      deep: true,
      handler: function(newValue, oldValue) {},
    },
    allFiltersShown: {
      handler: function(newValue, oldValue) {
        newValue === true || this.windowWidth < 768
          ? (this.visibleFiltersCount = this.singleBlock.filtersection.length)
          : (this.visibleFiltersCount = 7)
      },
    },
  },

  beforeMount() {
    this.setDefaultPriceRanges()
  },

  mounted() {
    this.setFiltersVisibility()

    mint.EventBus.on('mint:resize', () => {
      this.setFiltersVisibility()
    })

    this.$nextTick(() => {
      this.selectedFilters_ = this.allSelectedFilters
    })

    if (
      this.singleBlock['custom-fields'] &&
      this.singleBlock['custom-fields']['custom-field']
    ) {
      this.singleBlock['custom-fields']['custom-field'][0].value == 'Expanded'
        ? (this.hidePanel = false)
        : (this.hidePanel = true)
    }
  },
  methods: {
    togglePanel: function() {
      this.hidePanel = !this.hidePanel

      this.$emit('togglePanelState', {
        name: this.singleBlock.title,
        isOpen: !this.hidePanel,
      })
    },

    onCheckboxCheck(value) {
      this.$emit('blockInputChange', value)
    },

    onRemoveFilter(value) {
      this.$emit('removeFilter', value)
    },

    onMinPrice(evt) {
      this.sliderMin = evt.target.value
      this.priceFilter.minPrice = this.sliderMin
      this.priceFilter.maxPrice = this.sliderMax
      this.priceFilter.checked = true
      this.priceFilter.name =
        this.addCurrencySymbol(parseFloat(this.sliderMin).toFixed(0)) +
        ' < price < ' +
        this.addCurrencySymbol(parseFloat(this.sliderMax).toFixed(0))
      const filterString = `${this.priceFilter.minPrice}<${
        this.priceFilter.filter_on
      }<${this.priceFilter.maxPrice}`
      this.generateFiltersUrlAdd('price', filterString)
      this.$emit('blockInputChange', this.priceFilter)
    },

    onMaxPrice(evt) {
      this.sliderMax = evt.target.value
      this.priceFilter.maxPrice = this.sliderMax
      this.priceFilter.minPrice = this.sliderMin
      this.priceFilter.checked = true
      this.priceFilter.name =
        this.addCurrencySymbol(parseFloat(this.sliderMin).toFixed(0)) +
        ' < price < ' +
        this.addCurrencySymbol(parseFloat(this.sliderMax).toFixed(0))
      const filterString = `${this.priceFilter.minPrice}<${
        this.priceFilter.filter_on
      }<${this.priceFilter.maxPrice}`
      this.generateFiltersUrlAdd('price', filterString)
      this.$emit('blockInputChange', this.priceFilter)
    },

    addCurrencySymbol(priceValue) {
      return formatLocalizedPrice(priceValue * 100)
    },

    setDefaultPriceRanges() {
      const existingPriceFilter = this.allSelectedFilters.find(item => {
        return item.filter_on == mint.services.attraqt.priceField
      })
      if (this.singleBlock.on == mint.services.attraqt.priceField) {
        const min =
          existingPriceFilter?.minPrice || this.singleBlock.globalrange.min
        const max =
          existingPriceFilter?.maxPrice || this.singleBlock.globalrange.max
        const priceFilter = {
          sliderMin: min,
          sliderMax: max,
          name:
            this.addCurrencySymbol(parseFloat(min).toFixed(0)) +
            ' < price < ' +
            this.addCurrencySymbol(parseFloat(max).toFixed(0)),
          filter_on: window.mint.services.attraqt.priceField,
          checked: Boolean(existingPriceFilter),
        }
        this.minPrice = this.singleBlock.globalrange.min
        this.minAngle = min
        this.maxPrice = this.singleBlock.globalrange.max
        this.maxAngle = max
        this.priceFilter = priceFilter
      }
    },

    generateFiltersUrlAdd: function(group, value) {
      const currentSearchParam = new URLSearchParams(window.location.search)
      let initialFiltered = window.location.search
        ?.split('?filtered=[')[1]
        ?.split(']')[0]
      if (group === 'price' && initialFiltered) {
        initialFiltered = initialFiltered
          .split('&')
          .filter(item => {
            const group = item.split('=')[0]
            return group !== 'price'
          })
          .join('&')
      }

      let filteredBy = ''

      if (initialFiltered) {
        filteredBy = initialFiltered + `&${group}=${value}`
      } else {
        filteredBy = `${group}=${value}`
      }

      const sortCheck = currentSearchParam.get('fh_sort_by')
      if (sortCheck) {
        window.history.pushState(
          {},
          '',
          window.location.pathname +
            '?filtered=[' +
            filteredBy +
            ']&fh_sort_by=' +
            sortCheck,
        )
      } else {
        window.history.pushState(
          {},
          '',
          window.location.pathname + '?filtered=[' + filteredBy + ']',
        )
      }
    },

    generateFiltersUrlRemove: function(group, value) {
      const currentSearchParam = new URLSearchParams(window.location.search)
      const initialFiltered = window.location.search
        ?.split('?filtered=[')[1]
        ?.split(']')[0]

      if (initialFiltered) {
        let filteredBy
        if (group === 'price') {
          filteredBy = initialFiltered
            .split('&')
            .filter(item => {
              const group = item.split('=')[0]
              return group !== 'price'
            })
            .join('&')
        } else {
          const filterToRemoveMulti = `&${group}=${value}`
          const filterToRemoveSingle = `${group}=${value}`
          filteredBy = initialFiltered.replace(filterToRemoveMulti, '')
          filteredBy = filteredBy.replace(filterToRemoveSingle, '')
        }

        if (filteredBy.substring(0, 1) == '&')
          filteredBy = filteredBy.slice(1, filteredBy.length)

        const sortCheck = currentSearchParam.get('fh_sort_by')

        if (filteredBy.length > 0) {
          // More than 1 filter initially.
          filteredBy = `?filtered=[${filteredBy}]`
        }

        if (sortCheck) {
          const _urlParams =
            (filteredBy.length > 0 ? filteredBy + '&' : '?') +
            'fh_sort_by=' +
            sortCheck
          window.history.pushState(
            {},
            '',
            window.location.pathname + _urlParams,
          )
        } else {
          window.history.pushState(
            {},
            '',
            window.location.pathname + filteredBy,
          )
        }
      }
    },

    setFiltersVisibility() {
      this.windowWidth = window.innerWidth
      this.allFiltersShown = this.windowWidth < 768
    },
  },
}
</script>
